import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=8955ac74&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
import style0 from "./Empresas.vue?vue&type=style&index=0&id=8955ac74&prod&lang=css"
import style1 from "./Empresas.vue?vue&type=style&index=1&id=8955ac74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955ac74",
  null
  
)

export default component.exports